import type { AskAiCellValue } from '@/types/askAi';

export type AskAiRow = Record<string, AskAiCellValue>;

/** Zips `columns`/`rows` (the AskAiResponse wire shape) into row objects. */
export function rowsToObjects(columns: string[], rows: AskAiCellValue[][]): AskAiRow[] {
  return rows.map((row) => {
    const obj: AskAiRow = {};
    columns.forEach((col, i) => {
      obj[col] = row[i] ?? null;
    });
    return obj;
  });
}

export function toNumber(value: AskAiCellValue): number {
  if (typeof value === 'number') return value;
  if (typeof value === 'boolean') return value ? 1 : 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function toLabel(value: AskAiCellValue): string {
  return value === null || value === undefined ? '∅' : String(value);
}

export const tooltipStyle = {
  background: 'hsl(var(--popover))',
  border: '1px solid hsl(var(--border))',
  fontSize: 12,
  color: 'hsl(var(--popover-foreground))',
};

export const CHART_PALETTE = [
  'hsl(var(--primary))',
  'hsl(var(--accent))',
  'hsl(var(--destructive))',
  'hsl(var(--muted-foreground))',
  'hsl(var(--secondary))',
  'hsl(var(--ring))',
];
